
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import {alpha} from '@mui/material/styles';

import Link from '@src/components/base/Link';


export default function NavButton(
  {
    to,
    href,
    active = false,
    disabled = false,
    children,
    onClick,
    ...rest
  },
) {
  // Use ButtonBase so sx/styles always apply even if your Link doesn't handle sx.
  const Component = to || href ? Link : 'button';

  return (
    <ButtonBase
      disableRipple
      to={to}
      href={href}
      disabled={disabled}
      focusRipple={false}
      component={Component}
      sx={(theme) => ({
        // layout / spacing
        px: 1.5,
        py: 0.75,
        borderRadius: 1, // 8px
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        whiteSpace: 'nowrap',

        // typography
        fontSize: 14,
        lineHeight: 1.5,
        fontWeight: active ? 600 : 500,

        // colors
        color: active ? theme.palette.primary.main : theme.palette.text.secondary,

        // states
        '&:hover': {
          bgcolor: theme.palette.action.hover,
          color: active ? theme.palette.primary.main : theme.palette.text.primary,
        },
        '&:focus-visible': {
          boxShadow: `0 0 0 3px ${alpha(theme.palette.primary.main, 0.28)}`,
          outline: 0,
        },
        '&.Mui-disabled': {
          opacity: 0.5,
          pointerEvents: 'none',
        },
      })}
      onClick={onClick}
      {...rest}
    >
      <Box component="span" sx={{display: 'inline-flex', alignItems: 'center', gap: 1}}>
        {children}
      </Box>
    </ButtonBase>
  );
}
